import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Headphones } from 'lucide-react';
import VoiceAiCallList from '../../components/VoiceAiCallList';

export default function VoiceAiRecordings() {
  const navigate = useNavigate();

  return (
    <div className="w-full space-y-6 pb-12">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 border-b border-slate-200/80 pb-6">
        <div className="flex items-start gap-4">
          <button
            type="button"
            onClick={() => navigate('/voice-ai')}
            className="mt-1 p-2.5 rounded-xl border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50"
            aria-label="Back"
          >
            <ArrowLeft size={20} />
          </button>
          <div>
            <div className="flex items-center gap-2">
              <Headphones className="text-violet-600" size={22} />
              <h1 className="text-2xl font-bold text-slate-900">Call recordings</h1>
            </div>
            <p className="text-sm text-slate-500 mt-1">
              Voice AI pe aayi har call ki recording. Job bane ya na bane.
            </p>
          </div>
        </div>
      </div>
      <VoiceAiCallList fullPage />
    </div>
  );
}
